import React, { useState, useEffect } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { isLocalUser } from 'Utils/account/utils';
import ShareModal from './ShareModal';
import { Share } from '@mui/icons-material';

const TopMenuShare = ({ user, lan }) => {
	const [show, setShow] = useState(false);
	const [showModal, setShowModal] = useState(false);
	useEffect(() => {
		setShow(isLocalUser(user));
	}, [user]);
	const handleShowModal = () => {
		setShowModal(!showModal);
	};
	return (
		<>
			{show && (
				<>
					<Tooltip title={lan.share}>
						<IconButton
              onClick={handleShowModal}
              sx={{
                p: 0,
                color: 'text.secondary',
                transition: (theme) => theme.transitions.create('color'),
                '&:hover': {
                  backgroundColor: 'transparent',
                  color: 'primary.main',
                },
              }}
            >
							<Share fontSize="medium"/>
						</IconButton>
					</Tooltip>
					{showModal && <ShareModal closeDialog={handleShowModal} lan={lan} />}
				</>
			)}
		</>
	);
};
export default TopMenuShare;
